// extracted by mini-css-extract-plugin
export default {"left":"Left_left__6-y7h","logo":"Left_logo__gQ3PW","firstMessage":"Left_firstMessage__Auiv2","secondMessage":"Left_secondMessage__7guod","page":"Left_page__xr-Ki"};